module.exports = __webpack_public_path__ + "static/media/ac2.f1cddad1.jpg";